import { useIntl } from 'react-intl';

import { StagedChangesPill } from '@verantos-dev/shared-ui-components';

import { AdRevertModal } from './AdRevertModal';
import { AdSaveModal } from './AdSaveModal';
import { useAdStagedChangesPill } from '../hooks/useAdStagedChangesPill';

export const AdStagedChangesPill = () => {
  const { formatMessage } = useIntl();
  const {
    visible,
    isSaveOpen,
    isRevertOpen,
    onSaveClick,
    onRevertClick,
    onCloseSave,
    onCloseRevert,
  } = useAdStagedChangesPill();

  // Component stays mounted regardless of `visible` — modal mounts live at the
  // same level. Hiding the pill chrome on revert/save success must NOT take
  // the modals down with it, otherwise the modal's onClose timer is cancelled
  // and the open-flag never clears.
  return (
    <>
      <StagedChangesPill
        visible={visible}
        // Anchored to the detail page (position: relative) and draggable, so the
        // user can move it aside — matches the cohort builder's pill.
        position="absolute"
        draggable
        message={formatMessage({ id: 'analyticalDatasetDetail.stagedChanges.unsaved' })}
        secondaryButton={{
          label: formatMessage({ id: 'analyticalDatasetDetail.stagedChanges.revert' }),
          onClick: onRevertClick,
          'data-testid': 'ad-staged-changes-revert',
        }}
        primaryButton={{
          label: formatMessage({ id: 'analyticalDatasetDetail.stagedChanges.save' }),
          onClick: onSaveClick,
          'data-testid': 'ad-staged-changes-save',
        }}
        data-testid="ad-staged-changes-pill"
      />
      {isSaveOpen && <AdSaveModal onClose={onCloseSave} />}
      {isRevertOpen && <AdRevertModal onClose={onCloseRevert} />}
    </>
  );
};
